module.exports = __webpack_public_path__ + "img/coffeeMachine.7dad3ec5.png";